module.exports = __webpack_public_path__ + "img/ico_menual09_off.9f66762c.svg";